<template>
  <div class="telegram-menus-host">
    <!-- Group Menu -->
    <div v-if="groupMenu.open" class="telegram-popover-menu group-menu open" :style="{ left: groupMenu.x + 'px', top: groupMenu.y + 'px' }">
      <button class="telegram-popover-item" type="button" @click="groupAction('invite')">邀请新成员</button>
      <button class="telegram-popover-item" type="button" @click="openMemberManager">群成员管理</button>
      <button class="telegram-popover-item" type="button" @click="groupAction('topic')">创建新话题</button>
      <button v-if="isCurrentAdmin" class="telegram-popover-item" type="button" @click="groupAction('rename')">修改群名称</button>
      <button v-if="currentSessionHasMultipleTopics && !isCurrentTopicDefault" class="telegram-popover-item popover-danger" type="button" @click="groupAction('exit-topic')">关闭话题</button>
      <button class="telegram-popover-item popover-danger" type="button" @click="groupAction('exit')">退出群聊</button>
      <button v-if="isCurrentAdmin && isCurrentGroup" class="telegram-popover-item popover-danger" type="button" @click="showDismiss">解散群聊</button>
    </div>

    <!-- Reply Menu -->
    <div v-if="replyMenu.open" class="telegram-popover-menu reply-menu open" :style="{ left: replyMenu.x + 'px', top: replyMenu.y + 'px' }">
      <button class="telegram-popover-item reply" type="button" @click="doReply">
        <svg viewBox="0 0 24 24" fill="none"><path d="M9 10L4 15l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 15h9a7 7 0 0 1 7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        引用回复
      </button>
      <button class="telegram-popover-item" type="button" @click="openForward">
        <svg viewBox="0 0 24 24" fill="none"><path d="M15 14l5-5-5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 9H9a7 7 0 0 0-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        转发
      </button>
      <button class="telegram-popover-item" type="button" @click="copyMessage">
        <svg viewBox="0 0 24 24" fill="none"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" stroke-width="1.8"/></svg>
        复制文本
      </button>
      <button v-if="replyMenu.clickedImageUrl" class="telegram-popover-item" type="button" @click="copyImage">
        <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="9" r="2" stroke="currentColor" stroke-width="1.8"/><path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        复制图片
      </button>
      <button v-if="replyMenu.clickedFileUrl" class="telegram-popover-item" type="button" @click="downloadFile">
        <svg viewBox="0 0 24 24" fill="none"><path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 21h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
        下载文件
      </button>
      <button class="telegram-popover-item" type="button" @click="togglePin">
        <svg viewBox="0 0 24 24" fill="none"><path d="M12 2v8M9 4l3 3 3-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 12h14M8 12v4a4 4 0 008 0v-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        {{ isCurrentMessagePinned ? '取消置顶' : '置顶消息' }}
      </button>
      <button class="telegram-popover-item" type="button" @click="enterMultiSelect">
        <svg viewBox="0 0 24 24" fill="none"><path d="M9 11l3 3L22 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        多选
      </button>
    </div>

    <!-- Emoji Menu -->
    <div v-if="emojiMenu.open" class="telegram-popover-menu emoji-menu open" :style="{ left: emojiMenu.x + 'px', top: emojiMenu.y + 'px' }">
      <button v-for="emoji in emojiList" :key="emoji" class="telegram-popover-item emoji" type="button" :title="emojiName(emoji)" @click="insertEmoji(emoji)">{{ emoji }}</button>
    </div>

    <!-- Mention Menu -->
    <div
      v-if="mentionMenu.open && mentionMenu.members.length"
      ref="mentionEl"
      class="telegram-popover-menu mention-menu open"
      :style="mentionStyle"
    >
      <button
        v-for="(m, idx) in mentionMenu.members"
        :key="m.name"
        class="telegram-popover-item mention"
        :class="{ active: idx === activeIndex }"
        :ref="'mentionItem' + idx"
        type="button"
        @mouseenter="$store.commit('SET_MENTION_ACTIVE_INDEX', idx)"
        @click="insertMention(m.name)"
      >
        <div class="telegram-popover-avatar" :style="{ background: m.avatarUrl ? 'transparent' : (m.avatarBackground || '') }">
          <img v-if="m.avatarUrl" :src="m.avatarUrl" alt="" />
          <template v-else>{{ m.avatarText || (m.name || '?').slice(0, 1) }}</template>
        </div>
        <div class="telegram-popover-copy">
          <div class="telegram-popover-title">@{{ m.name }}</div>
          <div class="telegram-popover-sub">{{ m.sub || '群成员' }}</div>
        </div>
        <span v-if="m.type === 'agent'" class="telegram-mention-ai-tag">AI</span>
      </button>
    </div>

    <!-- 群成员管理弹窗 -->
    <div v-if="memberManagerOpen" class="mm-overlay" @click.self="memberManagerOpen = false">
      <div class="mm-dialog">
        <div class="group-dialog-head">
          <div class="group-dialog-title">群组空间 · {{ currentSessionName }}</div>
          <button class="group-dialog-close" type="button" @click="memberManagerOpen = false">&times;</button>
        </div>
        <input class="group-dialog-search" type="text" v-model="memberManagerQuery" placeholder="搜索成员" />
        <div class="group-dialog-note">当前群内:{{ memberManagerUserCount }}位成员,{{ memberManagerAgentCount }}个AGENT</div>
        <div class="group-dialog-member-list">
          <template v-if="filteredManagerMembers.length">
            <div v-for="m in filteredManagerMembers" :key="m.id" class="group-dialog-member">
              <div class="group-dialog-member-main">
                <div class="group-dialog-member-avatar" :style="{ background: m.avatarUrl ? 'transparent' : (m.avatarBackground || '') }">
                  <img v-if="m.avatarUrl" :src="m.avatarUrl" alt="" />
                  <template v-else>{{ m.avatarText }}</template>
                </div>
                <div class="group-dialog-member-copy">
                  <div class="group-dialog-member-name">
                    {{ m.name }}
                    <span v-if="m.isOwner" class="member-manager-owner-tag">群主</span>
                    <span v-if="m.type === 'agent'" class="member-manager-ai-tag">Agent</span>
                  </div>
                  <div class="group-dialog-member-sub">{{ m.type === 'agent' ? ('负责人：' + (m.ownerName || '—')) : m.isSelf ? '我自己' : m.isOwner ? '管理员' : '群成员' }}</div>
                </div>
              </div>
              <div class="member-manager-actions">
                <button v-if="!m.isSelf && (m.type !== 'agent' || m.ownerId === $store.state.currentUserId)" class="group-dialog-inline-btn" type="button" @click="enterChat(m)">进入会话</button>
                <button v-if="isCurrentAdmin && (m.type === 'agent' || !m.isSelf)" class="group-dialog-inline-btn member-manager-remove-btn" type="button" @click="removeMember(m)">移除</button>
              </div>
            </div>
          </template>
          <div v-else class="group-dialog-empty">暂无匹配成员</div>
        </div>
        <div class="mm-foot">
          <button class="group-dialog-btn primary" type="button" @click="memberManagerOpen = false">完成</button>
        </div>

      </div>
    </div>

    <!-- 移除确认弹窗 -->
    <div v-if="removeConfirmOpen" class="mm-overlay" @click.self="cancelRemove">
      <div class="mm-dialog" style="max-height:auto;">
        <div class="group-dialog-head">
          <div class="group-dialog-title">移除成员</div>
          <button class="group-dialog-close" type="button" @click="cancelRemove">&times;</button>
        </div>
        <div style="padding:0 18px 16px;">
          <div class="group-dialog-note">确定将「{{ removeTarget ? removeTarget.name : '' }}」从群聊中移除吗？移除后该成员将无法查看群聊消息。</div>
          <div v-if="removeError" class="group-dialog-note" style="color:#dc2626;background:rgba(239,68,68,.06);border-color:rgba(239,68,68,.12);">{{ removeError }}</div>
        </div>
        <div class="group-dialog-footer" style="padding:0 18px 16px;display:flex;justify-content:flex-end;gap:10px;">
          <button class="group-dialog-btn" type="button" @click="cancelRemove">取消</button>
          <button class="group-dialog-btn danger" type="button" @click="confirmRemove" :disabled="removeLoading">{{ removeLoading ? '移除中...' : '确认移除' }}</button>
        </div>
      </div>
    </div>
    <!-- Forward Modal -->
    <div v-if="forwardModal.open" class="forward-overlay" @click.self="closeForward">
      <div class="forward-panel">
        <div class="forward-left">
          <div class="forward-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            <input type="text" v-model="forwardSearch" placeholder="搜索" />
          </div>
          <div class="forward-list">
            <template v-for="group in forwardGroupedSessions">
              <div :key="'fgh-'+group.type" class="forward-group-label">{{ group.label }}</div>
              <label v-for="s in group.items" :key="'fi-'+s.key" class="forward-item" :class="{ selected: forwardSelected.includes(s.key) }">
                <input type="checkbox" :value="s.key" v-model="forwardSelected" style="display:none" />
                <div class="forward-check" :class="{ checked: forwardSelected.includes(s.key) }"></div>
                <div class="forward-avatar" :style="s.avatar ? { backgroundImage: 'url('+s.avatar+')' } : {}">{{ s.avatar ? '' : (s.name||'?').slice(0,1) }}</div>
                <div class="forward-info">
                  <div class="forward-name">{{ s.name }}<span v-if="s.type === 'agent'" class="forward-tag agent">Agent</span><span v-if="s.type === 'group'" class="forward-tag group">群组</span><span v-if="s.isSystem" class="forward-tag system">官方</span></div>
                  <div class="forward-sub">{{ s.type === 'agent' ? 'Agent 对话' : s.type === 'group' ? ('群组 · ' + (s.memberCount||0) + '人') : '同事' }}</div>
                </div>
              </label>
            </template>
          </div>
        </div>
        <div class="forward-right">
          <div class="forward-right-head"><span>分别发送给</span><span v-if="forwardSelected.length" class="forward-right-link">已选 {{ forwardSelected.length }} 个</span><span v-else class="forward-right-hint">尚未选择会话</span></div>
          <div v-if="forwardSelected.length" class="forward-selected-list">
            <div v-for="key in forwardSelected" :key="'fs-'+key" class="forward-selected-item"><span>{{ forwardSessionName(key) }}</span><button type="button" class="forward-selected-remove" @click="forwardSelected = forwardSelected.filter(k => k !== key)">×</button></div>
          </div>
          <div class="forward-preview"><div class="forward-preview-label">来自 {{ forwardModal.senderName }}:</div><div class="forward-preview-text">{{ forwardPreviewText }}</div></div>
          <input class="forward-comment" v-model="forwardComment" placeholder="给朋友留言..." @keydown.enter.prevent="doForward" />
          <div class="forward-actions"><button class="forward-btn primary" :disabled="!forwardSelected.length || forwardSending" @click="doForward">{{ forwardSending ? '发送中…' : '分别转发' }}</button><button class="forward-btn cancel" @click="closeForward">取消</button></div>
        </div>
      </div>
    </div>
    <!-- 解散群聊确认弹窗（teleport 到 body） -->
    <div v-show="dismissConfirm.open" class="ss-confirm-overlay" ref="dismissOverlay" @click.self="cancelDismiss">
      <div class="ss-confirm-dialog">
        <div class="ss-confirm-title">确认解散「{{ currentSessionName }}」？</div>
        <div class="ss-confirm-desc">解散后所有成员将无法再访问该群聊，操作不可恢复。</div>
        <div class="ss-confirm-actions">
          <button class="ss-confirm-btn" type="button" @click="cancelDismiss" :disabled="dismissConfirm.loading">取消</button>
          <button class="ss-confirm-btn danger" type="button" @click="confirmDismiss" :disabled="dismissConfirm.loading">{{ dismissConfirm.loading ? '处理中…' : '确认解散' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { api } from '../utils/api'
import { solidFromColor } from '../utils/avatarColor'

// 按类别成块排列（笑脸/反应/手势/爱心/庆祝符号/食物饮品/动物/植物/交通/体育/音乐/办公/时间/服饰），下方 .emoji-menu 滚动
// 元组 [字符, 中文名]：从中派生 EMOJI_LIST（保留顺序）和 EMOJI_NAMES（hover title 用），单一来源避免漂移
const EMOJI_DATA = [
  // 笑脸·情绪
  ['😀','大笑'],['😃','微笑'],['😄','开心'],['😁','露牙'],['😆','眯笑'],['😅','苦笑'],['😂','笑哭'],['🤣','爆笑'],['😊','害羞'],['🙂','浅笑'],
  ['🙃','倒脸'],['😉','眨眼'],['😌','舒心'],['😍','花痴'],['🥰','充爱'],['😘','飞吻'],['😋','馋嘴'],['😜','调皮'],['🤪','抓狂'],['😎','酷'],
  ['🥳','庆祝'],['🤩','星眼'],['🤗','拥抱'],['🤔','思考'],['😇','天使'],['🤭','偷笑'],['🤫','嘘'],['😐','平静'],['😶','沉默'],['🙄','翻眼'],
  ['😏','得意'],['😒','不屑'],['😞','失落'],['😔','沮丧'],['😟','担心'],['🙁','不悦'],['😣','难受'],['😖','困扰'],['😫','疲惫'],['😩','厌倦'],
  ['🥺','委屈'],['😢','哭泣'],['😭','大哭'],['😤','哼气'],['😠','生气'],['😡','愤怒'],['🤯','炸裂'],['😳','脸红'],['😱','尖叫'],['😨','害怕'],
  // 反应·特殊
  ['🥵','发烫'],['🥶','冻僵'],['🤤','流口水'],['😴','睡觉'],['😪','困倦'],['🤢','反胃'],['🤮','呕吐'],['😷','口罩'],['🤒','发烧'],['🤕','受伤'],
  ['🤑','财迷'],['🤠','牛仔'],['😈','笑魔'],['👻','幽灵'],['💀','骷髅'],['🤖','机器'],['🎃','南瓜'],['👽','外星'],
  // 手势·肢体
  ['👋','挥手'],['🤚','举手'],['🖐️','张手'],['✋','停手'],['👌','OK'],['👐','双手'],['🖖','瓦肯'],['✌️','胜利'],['🤞','交指'],['🤟','爱你'],
  ['🤘','摇滚'],['🤙','打电话'],['👈','左指'],['👉','右指'],['👆','上指'],['👇','下指'],['☝️','一指'],['👍','赞'],['👎','踩'],['✊','拳头'],
  ['👊','出拳'],['🤛','左拳'],['🤜','右拳'],['👏','鼓掌'],['🙌','欢呼'],['🤲','捧手'],['🤝','握手'],['🙏','合十'],['💪','肌肉'],['💟','心饰'],
  // 爱心
  ['❤️','红心'],['🧡','橙心'],['💛','黄心'],['💚','绿心'],['💙','蓝心'],['💜','紫心'],['🖤','黑心'],['🤍','白心'],['💔','心碎'],['❣️','心叹'],
  ['💕','双心'],['💖','闪心'],['💗','跳心'],['💘','箭心'],['💝','礼心'],
  // 庆祝·符号·天气
  ['🎉','庆祝'],['🎊','彩纸'],['🎁','礼物'],['🎂','蛋糕'],['🎈','气球'],['🎀','蝴蝶结'],['🌹','玫瑰'],['💐','花束'],['⭐','星星'],['🌟','闪星'],
  ['✨','闪光'],['⚡','闪电'],['🔥','火'],['💥','爆炸'],['💫','晕眩'],['🌈','彩虹'],['☀️','太阳'],['🌙','月亮'],['❄️','雪花'],['💯','满分'],
  ['✅','对勾'],['❌','错号'],['❓','问号'],['❗','感叹'],['⚠️','警告'],['💡','灯泡'],['🔔','铃铛'],['⏰','闹钟'],['👀','看着'],['🎯','靶心'],
  // 食物·水果零食
  ['🍎','苹果'],['🍊','橙子'],['🍌','香蕉'],['🍉','西瓜'],['🍇','葡萄'],['🍓','草莓'],['🍑','桃子'],['🍒','樱桃'],['🍰','蛋糕'],['🍪','饼干'],
  ['🍫','巧克力'],['🍬','糖果'],['🍩','甜甜圈'],['🍕','披萨'],['🍔','汉堡'],['🍟','薯条'],['🍜','拉面'],['🍣','寿司'],['🍙','饭团'],['🌮','塔可'],
  // 饮品
  ['☕','咖啡'],['🍵','茶'],['🥛','牛奶'],['🥤','汽水'],['🍺','啤酒'],['🍻','干杯'],['🍷','红酒'],['🍸','鸡尾酒'],['🥂','香槟'],['🍹','果汁'],
  // 食物·主食 / 早餐 / 烘焙
  ['🍞','面包'],['🥐','牛角'],['🥖','法棍'],['🥨','椒盐'],['🧀','奶酪'],['🥚','鸡蛋'],['🍳','煎蛋'],['🥞','松饼'],['🥓','培根'],['🥩','肉排'],
  ['🍗','鸡腿'],['🍖','烤肉'],['🌭','热狗'],['🍿','爆米花'],['🥗','沙拉'],['🥘','焖锅'],['🍲','炖锅'],['🥟','饺子'],['🥧','派'],['🍯','蜂蜜'],
  // 蔬果·零食
  ['🥭','芒果'],['🥥','椰子'],['🥝','猕猴桃'],['🍅','番茄'],['🍆','茄子'],['🥑','牛油果'],['🥦','西兰花'],['🥒','黄瓜'],['🌶️','辣椒'],['🌽','玉米'],
  ['🥕','胡萝卜'],['🥔','土豆'],['🍠','红薯'],['🥜','花生'],['🌰','栗子'],['🍡','团子'],['🍧','刨冰'],['🍨','雪糕'],['🍦','冰激凌'],['🥮','月饼'],
  // 动物·哺乳
  ['🐶','狗狗'],['🐱','猫咪'],['🐭','老鼠'],['🐹','仓鼠'],['🐰','兔子'],['🦊','狐狸'],['🐻','熊'],['🐼','熊猫'],['🐨','考拉'],['🐯','老虎'],
  ['🦁','狮子'],['🐮','奶牛'],['🐷','小猪'],['🐸','青蛙'],['🐵','猴子'],['🙈','不看'],['🙉','不听'],['🙊','不说'],['🦄','独角兽'],['🐝','蜜蜂'],
  // 动物·猫脸 / 鸟 / 虫鱼海
  ['😺','笑猫'],['😸','露牙猫'],['😹','笑哭猫'],['😻','爱心猫'],['😼','坏笑猫'],['😽','飞吻猫'],['🙀','惊猫'],['😿','哭猫'],
  ['🐔','公鸡'],['🐧','企鹅'],['🐦','小鸟'],['🐤','小鸡'],['🐣','雏鸡'],['🦆','鸭子'],['🦅','老鹰'],['🦉','猫头鹰'],['🦇','蝙蝠'],['🐺','狼'],
  ['🦋','蝴蝶'],['🐌','蜗牛'],['🐞','瓢虫'],['🐢','乌龟'],['🐍','蛇'],['🐙','章鱼'],['🦀','螃蟹'],['🐠','热带鱼'],['🐬','海豚'],['🐳','鲸鱼'],
  // 植物·自然
  ['🌵','仙人掌'],['🌲','松树'],['🌳','大树'],['🌴','棕榈'],['🌱','嫩芽'],['🌿','香草'],['☘️','三叶'],['🍀','四叶'],['🍃','飘叶'],['🍂','落叶'],
  ['🍁','枫叶'],['🍄','蘑菇'],['🌷','郁金香'],['🌸','樱花'],['🌻','向日葵'],
  // 交通·旅行 / 地标
  ['🚗','汽车'],['🚕','出租'],['🚙','越野'],['🚌','公交'],['🚑','救护'],['🚒','消防'],['🏍️','摩托'],['🚲','单车'],['✈️','飞机'],['🚀','火箭'],
  ['⛵','帆船'],['🚂','蒸汽'],['🚄','高铁'],['🚁','直升机'],['🛸','飞碟'],['🏝️','海岛'],['🏖️','沙滩'],['🌋','火山'],['⛰️','山'],['🗽','自由'],
  // 体育·游戏
  ['🏆','奖杯'],['🥇','金牌'],['🥈','银牌'],['🥉','铜牌'],['⚽','足球'],['🏀','篮球'],['🏈','橄榄'],['⚾','棒球'],['🎾','网球'],['🏐','排球'],
  ['⛳','高尔夫'],['🎳','保龄'],['🎮','游戏'],['🎲','骰子'],['🧩','拼图'],
  // 音乐·乐器
  ['🎼','乐谱'],['🎵','单音'],['🎶','多音'],['🎤','麦克'],['🎧','耳机'],['🎷','萨克'],['🎸','吉他'],['🎹','钢琴'],['🎺','小号'],['🥁','鼓'],
  // 办公·科技 / 通讯
  ['💻','笔电'],['⌨️','键盘'],['🖱️','鼠标'],['🖥️','显示器'],['📷','相机'],['📹','摄像'],['🎥','摄影'],['📞','电话'],['📱','手机'],['📺','电视'],
  ['💾','软盘'],['💿','光盘'],['🔋','电池'],['🔌','插头'],['📡','天线'],['🔧','扳手'],['🔨','锤子'],['⚙️','齿轮'],['🔑','钥匙'],
  ['✉️','信封'],['📧','邮件'],['📦','包裹'],['📌','图钉'],['📝','备忘'],
  // 时间
  ['🕐','1点'],['🕑','2点'],['🕒','3点'],['🕓','4点'],['🕔','5点'],['🕕','6点'],['🕖','7点'],['🕗','8点'],['🕘','9点'],['🕙','10点'],
  ['🕚','11点'],['🕛','12点'],['⌛','沙漏'],['⏳','流沙'],
  // 服饰·配饰
  ['👑','王冠'],['🎩','礼帽'],['🎓','学位帽'],['🧢','棒球帽'],['👓','眼镜'],['👕','T恤'],['👖','牛仔'],['👗','裙子'],['👠','高跟'],['👜','包包']
]
const EMOJI_LIST = EMOJI_DATA.map(([c]) => c)
const EMOJI_NAMES = Object.fromEntries(EMOJI_DATA)

export default {
  name: 'TelegramMenus',
  data() {
    return {
      emojiList: EMOJI_LIST,
      mentionTop: null,
      memberManagerOpen: false,
      memberManagerQuery: '',
      memberManagerList: [],
      removeConfirmOpen: false,
      removeTarget: null,
      removeLoading: false,
      removeError: '',
      forwardSearch: '',
      forwardSelected: [],
      forwardComment: '',
      forwardSending: false,
      dismissConfirm: { open: false, loading: false }
    }
  },
  computed: {
    ...mapState(['telegramGroupMenu', 'telegramReplyMenu', 'telegramEmojiMenu', 'telegramMentionMenu', 'composerInputValues', 'currentTopicsPageKey', 'currentSessionKey', 'mentionActiveIndex']),
    activeIndex() { return this.mentionActiveIndex },
    groupMenu() { return this.telegramGroupMenu },
    replyMenu() { return this.telegramReplyMenu },
    isCurrentMessagePinned() {
      const messageId = this.replyMenu && this.replyMenu.messageId
      if (!messageId) return false
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      const conversationId = item && item.conversationId
      if (!conversationId) return false
      const topicId = this.$store.state.currentTopicKey
      const key = `${conversationId}::${topicId || 'default'}`
      const list = this.$store.state.conversationPinnedMessages[key] || []
      return list.some(p => p.messageId === messageId)
    },
    emojiMenu() { return this.telegramEmojiMenu },
    mentionMenu() { return this.telegramMentionMenu },
    hasTopics() { return !!this.currentTopicsPageKey },
    isCurrentAdmin() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return !!(item && item.isAdmin)
    },
    currentSessionHasMultipleTopics() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return !!(item && item.hasTopics)
    },
    isCurrentGroup() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return !!(item && item.type === 'group')
    },
    currentSessionName() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return item ? item.name : ''
    },
    memberManagerUserCount() {
      return this.memberManagerList.filter(m => m.type !== 'agent').length
    },
    memberManagerAgentCount() {
      return this.memberManagerList.filter(m => m.type === 'agent').length
    },
    filteredManagerMembers() {
      const q = (this.memberManagerQuery || '').trim().toLowerCase()
      const list = this.memberManagerList
      return q ? list.filter(m => (m.name || '').toLowerCase().includes(q)) : list
    },
    isCurrentTopicDefault() {
      if (!this.currentTopicsPageKey) return false
      const page = this.$store.state.sessionTopicPages[this.currentTopicsPageKey]
      if (!page) return false
      const topicId = this.$store.state.currentTopicKey
      const topic = page.topics.find(t => t.key === topicId)
      return !!(topic && topic.isDefault)
    },
    mentionStyle() {
      const m = this.mentionMenu
      if (!m || !m.open) return {}
      return {
        left: m.x + 'px',
        top: (this.mentionTop != null ? this.mentionTop : m.y) + 'px'
      }
    },
    forwardModal() { return this.$store.state.forwardModal },
    forwardGroupedSessions() {
      const all = this.$store.state.sessionItems.filter(s => !s.exited)
      const q = this.forwardSearch.trim().toLowerCase()
      const filtered = q ? all.filter(s => (s.name || '').toLowerCase().includes(q)) : all
      const groups = [
        { type: 'agent', label: 'Agent', items: filtered.filter(s => s.type === 'agent') },
        { type: 'coworker', label: '同事', items: filtered.filter(s => s.type === 'coworker') },
        { type: 'group', label: '群组', items: filtered.filter(s => s.type === 'group') }
      ]
      return groups.filter(g => g.items.length)
    },
    forwardPreviewText() {
      const m = this.forwardModal
      if (!m) return ''
      if (m.kind === 'image') return '[图片] ' + (m.fileName || '')
      if (m.kind === 'file' || m.kind === 'document') return '[文件] ' + (m.fileName || '')
      if (m.kind === 'video') return '[视频]'
      if (m.kind === 'audio') return '[语音]'
      return m.text || ''
    }
  },
  watch: {
    mentionActiveIndex(idx) {
      this.$nextTick(() => {
        const ref = this.$refs['mentionItem' + idx]
        const el = Array.isArray(ref) ? ref[0] : ref
        if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' })
      })
    },
    'mentionMenu.open'(open) {
      this.mentionTop = null
      if (open) this.$nextTick(() => this.repositionMention())
    },
    'mentionMenu.members'() {
      if (this.mentionMenu.open) {
        this.mentionTop = null
        this.$nextTick(() => this.repositionMention())
      }
    }
  },
  methods: {
    ...mapMutations(['SET_TELEGRAM_GROUP_MENU', 'SET_TELEGRAM_REPLY_MENU', 'SET_TELEGRAM_EMOJI_MENU', 'SET_TELEGRAM_MENTION_MENU', 'CLOSE_TELEGRAM_MENUS', 'SET_GROUP_DIALOG', 'SET_TELEGRAM_PENDING_REPLY', 'SET_COMPOSER_INPUT', 'ADD_PENDING_MENTION']),
    emojiName(e) { return EMOJI_NAMES[e] || '' },
    groupAction(mode) {
      this.CLOSE_TELEGRAM_MENUS()
      this.SET_GROUP_DIALOG({ open: true, mode, sessionKey: this.currentSessionKey })
    },
    showDismiss() {
      this.CLOSE_TELEGRAM_MENUS()
      this.dismissConfirm = { open: true, loading: false }
    },
    cancelDismiss() {
      this.dismissConfirm = { open: false, loading: false }
    },
    async confirmDismiss() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      const convId = item ? item.conversationId : null
      if (!convId) { this.dismissConfirm = { open: false, loading: false }; return }
      this.dismissConfirm.loading = true
      try {
        const { api } = require('../utils/api')
        await api.dismissConversation(convId)
        await this.$store.dispatch('fetchConversations', { force: true })
        // 解散后立即刷新账号级总未读，否则解散群的未读会一直挂在 totalUnread 上，等轮询才消失
        this.$store.dispatch('fetchUnreadCount')
        this.dismissConfirm = { open: false, loading: false }
      } catch (e) {
        console.warn('[TelegramMenus] dismissConversation failed:', e && e.message)
        this.dismissConfirm.loading = false
      }
    },
    async openMemberManager() {
      this.CLOSE_TELEGRAM_MENUS()
      this.memberManagerQuery = ''
      this.memberManagerList = []
      this.memberManagerOpen = true
      const convId = this.$store.getters.currentConversationId
      if (!convId) return
      const currentUserId = this.$store.state.currentUserId
      try {
        const data = await api.getGroupMembers(convId)
        const members = Array.isArray(data) ? data : (data && data.members ? data.members : [])
        this.memberManagerList = members.map((m) => ({
          id: m.userId,
          agentId: m.agentId || null,
          name: m.name || '成员',
          type: m.type === 'agent' ? 'agent' : 'account',
          avatarUrl: m.avatarUrl || null,
          avatarText: (m.name || '?').slice(0, 1),
          avatarBackground: solidFromColor(m.avatarColorRgb),
          role: m.role || '',
          isSelf: m.userId === currentUserId && m.type !== 'agent',
          isOwner: m.role === 'admin' || m.role === 'owner',
          ownerName: m.ownerName || m.owner_name || '',
          ownerId: m.ownerId || m.owner_id || ''
        }))
      } catch (e) {
        console.warn('[TelegramMenus] getGroupMembers failed:', e.message)
      }
    },
    removeMember(member) {
      this.removeTarget = member
      this.removeConfirmOpen = true
    },
    async confirmRemove() {
      const member = this.removeTarget
      if (!member) return
      this.removeLoading = true
      const convId = this.$store.getters.currentConversationId
      if (!convId) return
      try {
        const { api } = require('../utils/api')
        if (member.type === 'agent') {
          await api.kickAgentFromConversation(convId, member.agentId)
        } else {
          await api.kickMemberFromConversation(convId, member.id)
        }
        this.memberManagerList = this.memberManagerList.filter(m => {
          if (member.type === 'agent') return m.agentId !== member.agentId
          return m.id !== member.id || m.type === 'agent'
        })
        this.$store.dispatch('fetchMentionableMembers', convId)
        this.removeConfirmOpen = false
        this.removeTarget = null
      } catch (e) {
        this.removeError = e.message || '移除失败'
      } finally {
        this.removeLoading = false
      }
    },
    cancelRemove() {
      this.removeConfirmOpen = false
      this.removeTarget = null
      this.removeError = ''
    },
    async enterChat(m) {
      this.memberManagerOpen = false
      try {
        await this.$store.dispatch('createDirectSession', { participantId: m.id })
      } catch (e) {
        console.warn('[TelegramMenus] enterChat failed:', e.message)
      }
    },
    doReply() {
      this.SET_TELEGRAM_PENDING_REPLY({
        name: this.replyMenu.name,
        text: this.replyMenu.text,
        messageId: this.replyMenu.messageId,
        kind: this.replyMenu.kind || 'text',
        files: this.replyMenu.files || null,
        imageUrl: this.replyMenu.imageUrl || '',
        fileName: this.replyMenu.fileName || ''
      })
      this.CLOSE_TELEGRAM_MENUS()
      this.$nextTick(() => {
        const ta = document.querySelector('.telegram-editor textarea')
        if (ta) ta.focus()
      })
    },
    copyMessage() {
      const text = this.replyMenu.text || ''
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).catch(() => {})
      } else {
        const ta = document.createElement('textarea')
        ta.value = text
        ta.style.cssText = 'position:fixed;opacity:0'
        document.body.appendChild(ta)
        ta.select()
        try { document.execCommand('copy') } catch {}
        document.body.removeChild(ta)
      }
      this.CLOSE_TELEGRAM_MENUS()
    },
    async copyImage() {
      const url = this.replyMenu.clickedImageUrl
      this.CLOSE_TELEGRAM_MENUS()
      if (!url) return
      let blob = null
      try {
        const resp = await fetch(url, { mode: 'cors', credentials: 'omit' })
        if (!resp.ok) throw new Error('HTTP ' + resp.status)
        blob = await resp.blob()
      } catch (e) {
        console.warn('[copyImage] fetch failed:', e)
      }
      // 路径 A：async clipboard（仅 HTTPS / 安全上下文可用）
      if (blob && window.isSecureContext && window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
        try {
          const pngBlob = blob.type === 'image/png' ? blob : await this._imageBlobToPng(blob)
          await navigator.clipboard.write([new ClipboardItem({ 'image/png': pngBlob })])
          console.log('[copyImage] async clipboard OK')
          return
        } catch (e) {
          console.warn('[copyImage] async clipboard write failed:', e)
        }
      }
      // 路径 B：contenteditable + 已加载渲染的 <img> + selectNode + execCommand
      //         让 Chromium 把位图写进系统剪贴板（CF_DIB / CF_BITMAP），微信/QQ 才认
      if (blob) {
        try {
          const ok = await this._copyImgAsBitmap(blob)
          if (ok) { console.log('[copyImage] bitmap-copy OK'); return }
        } catch (e) {
          console.warn('[copyImage] bitmap-copy failed:', e)
        }
        // 路径 C：copy 事件拦截写 HTML（web 应用能收，原生 IM 不行）
        try {
          const dataUrl = await this._blobToDataUrl(blob)
          const ok = this._copyHtmlViaCopyEvent(`<img src="${dataUrl}">`, '[图片]')
          if (ok) { console.log('[copyImage] html-copy OK (web app only)'); return }
        } catch (e) {
          console.warn('[copyImage] html-copy failed:', e)
        }
      }
      // 路径 D：兜底复制 URL 文本
      const okText = this._copyHtmlViaCopyEvent(null, url)
      if (!okText) console.warn('[copyImage] all paths failed')
    },
    async downloadFile() {
      const url = this.replyMenu.clickedFileUrl
      const name = this.replyMenu.clickedFileName || 'download'
      this.CLOSE_TELEGRAM_MENUS()
      if (!url) return
      try {
        const res = await fetch(url)
        if (!res.ok) throw new Error('HTTP ' + res.status)
        const blob = await res.blob()
        const blobUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = name
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000)
      } catch (e) {
        console.warn('[downloadFile] fetch failed, fallback to open:', e)
        window.open(url, '_blank')
      }
    },
    _copyImgAsBitmap(blob) {
      return new Promise((resolve) => {
        const blobUrl = URL.createObjectURL(blob)
        const div = document.createElement('div')
        div.contentEditable = 'true'
        // 关键：要 viewport 内且实际渲染过；opacity:0/display:none/离屏都会让 Chromium 跳过位图写入
        div.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;overflow:hidden;opacity:0.01;pointer-events:none;z-index:-9999;background:#fff'
        const img = document.createElement('img')
        img.style.cssText = 'display:block;'
        let settled = false
        const finish = (ok) => {
          if (settled) return
          settled = true
          URL.revokeObjectURL(blobUrl)
          try { document.body.removeChild(div) } catch (_) {}
          resolve(ok)
        }
        img.onload = () => {
          // 等两帧 RAF 确保完成 paint
          requestAnimationFrame(() => requestAnimationFrame(() => {
            try {
              div.focus()
              const sel = window.getSelection()
              const range = document.createRange()
              range.selectNode(img)
              sel.removeAllRanges()
              sel.addRange(range)
              let ok = false
              try { ok = document.execCommand('copy') } catch (e) { console.warn('[bitmap-copy] execCommand threw:', e) }
              sel.removeAllRanges()
              finish(ok)
            } catch (e) {
              console.warn('[bitmap-copy] select/copy threw:', e)
              finish(false)
            }
          }))
        }
        img.onerror = (e) => { console.warn('[bitmap-copy] img load failed', e); finish(false) }
        img.src = blobUrl
        div.appendChild(img)
        document.body.appendChild(div)
        setTimeout(() => finish(false), 8000)
      })
    },
    _imageBlobToPng(blob) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const objUrl = URL.createObjectURL(blob)
        img.onload = () => {
          const c = document.createElement('canvas')
          c.width = img.naturalWidth
          c.height = img.naturalHeight
          c.getContext('2d').drawImage(img, 0, 0)
          c.toBlob(b => { URL.revokeObjectURL(objUrl); b ? resolve(b) : reject(new Error('toBlob failed')) }, 'image/png')
        }
        img.onerror = () => { URL.revokeObjectURL(objUrl); reject(new Error('image load failed')) }
        img.src = objUrl
      })
    },
    _blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const r = new FileReader()
        r.onload = () => resolve(r.result)
        r.onerror = () => reject(r.error || new Error('FileReader failed'))
        r.readAsDataURL(blob)
      })
    },
    // 通用：拦截 copy 事件强写 clipboardData。html=null 则只写 text。
    _copyHtmlViaCopyEvent(html, plainText) {
      const ta = document.createElement('textarea')
      ta.value = plainText || ' '
      ta.setAttribute('readonly', '')
      ta.style.cssText = 'position:fixed;top:0;left:0;width:2em;height:2em;padding:0;border:0;opacity:0;'
      document.body.appendChild(ta)
      const handler = (e) => {
        try {
          e.preventDefault()
          if (html) e.clipboardData.setData('text/html', html)
          e.clipboardData.setData('text/plain', plainText || '')
        } catch (err) { console.warn('[clipboardData.setData] failed:', err) }
      }
      document.addEventListener('copy', handler, { once: true, capture: true })
      ta.focus()
      ta.select()
      let ok = false
      try { ok = document.execCommand('copy') } catch (e) { console.warn('[execCommand copy] threw:', e) }
      document.removeEventListener('copy', handler, { capture: true })
      document.body.removeChild(ta)
      return ok
    },
    enterMultiSelect() {
      const rm = this.replyMenu
      const msg = { id: rm.messageId, seq: rm.seq || 0, name: rm.name || '', text: rm.text || '', kind: rm.kind || 'text', fileName: rm.fileName || '', imageUrl: rm.imageUrl || '', fileUrl: rm.fileUrl || '', mimeType: rm.mimeType || '', fileSizeStr: rm.fileSizeStr || '' }
      this.$store.commit('CLOSE_TELEGRAM_MENUS')
      this.$store.commit('ENTER_MULTI_SELECT', msg)
    },
    togglePin() {
      const rm = this.replyMenu
      const messageId = rm && rm.messageId
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      const conversationId = item && item.conversationId
      if (!messageId || !conversationId) {
        this.$store.commit('CLOSE_TELEGRAM_MENUS')
        return
      }
      const topicId = this.$store.state.currentTopicKey || undefined
      const wasPinned = this.isCurrentMessagePinned
      this.$store.commit('CLOSE_TELEGRAM_MENUS')
      if (wasPinned) {
        this.$store.dispatch('unpinMessage', { conversationId, topicId, messageId })
      } else {
        const message = {
          id: messageId,
          sender: { id: rm.senderId || '', name: rm.name || '' },
          body: { text: rm.text || '' },
          createdAt: rm.createdAt || new Date().toISOString()
        }
        this.$store.dispatch('pinMessage', { conversationId, topicId, message })
      }
    },
    openForward() {
      const rm = this.replyMenu
      this.$store.commit('CLOSE_TELEGRAM_MENUS')
      this.$store.commit('SET_FORWARD_MODAL', {
        open: true, senderName: rm.name || '未知', text: rm.text || '',
        kind: rm.kind || 'text', imageUrl: rm.imageUrl || '',
        fileUrl: rm.fileUrl || '', fileName: rm.fileName || '',
        mimeType: rm.mimeType || '', files: rm.files || null,
        imageWidth: rm.imageWidth || 0, imageHeight: rm.imageHeight || 0,
        fileSize: rm.fileSize || 0, fileSizeStr: rm.fileSizeStr || ''
      })
      this.forwardSearch = ''
      this.forwardSelected = []
      this.forwardComment = ''
    },
    closeForward() {
      this.$store.commit('CLOSE_FORWARD_MODAL')
      this.forwardSearch = ''
      this.forwardSelected = []
      this.forwardComment = ''
      this.forwardSending = false
    },
    forwardSessionName(key) {
      const s = this.$store.state.sessionItems.find(i => i.key === key)
      return s ? s.name : key
    },
    _buildForwardFile(m) {
      const url = m.imageUrl || m.fileUrl || ''
      if (!url) return null
      const file = { url, name: m.fileName || '', type: m.kind || 'file', mimeType: m.mimeType || '' }
      if (m.fileSize) file.size = m.fileSize
      if (m.kind === 'image') {
        file.type = 'image'
        if (m.imageWidth) file.width = m.imageWidth
        if (m.imageHeight) file.height = m.imageHeight
      }
      return file
    },
    _stripForwardPrefix(text) {
      if (!text) return ''
      let t = text
      let prev = ''
      while (t !== prev) {
        prev = t
        // 只去转发前缀行，保留其余内容（包括留言）
        t = t.replace(/^【转发消息】来自\s+\S+?[：:]\s*/, '')
             .replace(/^【合并转发】\n?/, '')
             .replace(/^转发自\s+\S+?[：:]\s*/, '')
             .replace(/^转发自\s+\S+?\s*\n/, '')  // "转发自 XXX\n" 无冒号、后面还有内容
             .replace(/^转发自\s+\S+?\s*$/, '')    // "转发自 XXX" 无冒号、到末尾
      }
      // 去掉开头的 "留言：" 前缀（上一轮留言变成了正文开头）
      t = t.replace(/^留言：/, '')
      return t.trim()
    },
    async _forwardOneMsg(convId, m, comment, topicId) {
      const from = m.senderName || m.name || '未知'
      const file = this._buildForwardFile(m)
      const cleanText = this._stripForwardPrefix(m.text)
      if (file) {
        let caption = '转发自 ' + from
        if (cleanText) caption += '：' + cleanText
        if (comment) caption += '\n留言：' + comment
        await api.sendMediaMessage(convId, { messageType: 'file', body: { files: [file], caption }, topicId })
      } else {
        let text = '【转发消息】来自 ' + from + '：' + (cleanText || '')
        if (comment) text += '\n留言：' + comment
        await api.sendMessage(convId, { text, topicId })
      }
    },
    async doForward() {
      if (!this.forwardSelected.length || this.forwardSending) return
      this.forwardSending = true
      const fm = this.forwardModal
      const comment = this.forwardComment.trim()
      const sessions = this.forwardSelected.map(key => this.$store.state.sessionItems.find(i => i.key === key)).filter(s => s && s.conversationId)

      try {
        const _getTopicId = (s) => {
          const page = s.topicKey && this.$store.state.sessionTopicPages[s.topicKey]
          if (page && page.activeKey) return page.activeKey
          if (page && page.topics && page.topics.length) return page.topics[0].key
          return undefined
        }
        if (fm.kind === 'multi-forward-each' && fm._messages) {
          // 逐条转发
          for (const s of sessions) {
            const topicId = _getTopicId(s)
            for (const m of fm._messages) {
              try { await this._forwardOneMsg(s.conversationId, m, comment, topicId) } catch (e) { /* ignore */ }
            }
          }
        } else if (fm.kind === 'multi-forward-merge' && fm._messages) {
          // 合并转发：编码成一条文本消息，图片 URL 内嵌，渲染端解析
          const lines = fm._messages.map(m => {
            const from = m.senderName || m.name || '未知'
            const imgUrl = m.imageUrl || (m.kind === 'image' ? (m.fileUrl || '') : '')
            const fileUrl = (!imgUrl && m.fileUrl) ? m.fileUrl : ''
            const cleanText = this._stripForwardPrefix(m.text)
            let line = from + '：'
            if (imgUrl) line += '[img:' + imgUrl + ']'
            if (fileUrl) line += '[file:' + (m.fileName || '文件') + ':' + (m.fileSizeStr || '') + ':' + fileUrl + ']'
            if (cleanText) line += cleanText
            return line
          })
          const text = '【合并转发】\n' + lines.join('\n')
          for (const s of sessions) {
            const topicId = _getTopicId(s)
            try { await api.sendMessage(s.conversationId, { text, topicId }) } catch (e) { /* ignore */ }
          }
        } else {
          // 单条转发
          for (const s of sessions) {
            const topicId = _getTopicId(s)
            try { await this._forwardOneMsg(s.conversationId, fm, comment, topicId) } catch (e) { /* ignore */ }
          }
        }
      } finally {
        this.forwardSending = false
        this.closeForward()
      }
    },
    insertEmoji(emoji) {
      const { context, selStart, selEnd, val, textareaId } = this.emojiMenu
      const newVal = val.slice(0, selStart) + emoji + val.slice(selEnd)
      this.SET_COMPOSER_INPUT({ context, value: newVal })
      this.CLOSE_TELEGRAM_MENUS()
      // 焦点回到输入框，光标停在刚插入的 emoji 之后；不然焦点还在弹窗里关掉的按钮上，连续输入断了
      this.$nextTick(() => {
        const ta = textareaId ? document.getElementById(textareaId) : null
        if (!ta) return
        ta.focus()
        // textarea selection 用 UTF-16 单位，跟 emoji.length 同口径（emoji 是代理对时是 2，组合序列更多）
        const pos = selStart + emoji.length
        ta.setSelectionRange(pos, pos)
      })
    },
    insertMention(name) {
      const { context, atStart, query, val, members, textareaId } = this.mentionMenu
      const member = members.find(m => m.name === name)
      const displayText = `@${name} `
      const newVal = val.slice(0, atStart) + displayText + val.slice(atStart + 1 + query.length)
      this.SET_COMPOSER_INPUT({ context, value: newVal })
      if (member) {
        this.ADD_PENDING_MENTION({ name, mention: { id: member.id, type: member.type || 'user', name: member.name } })
      }
      this.CLOSE_TELEGRAM_MENUS()
      this.$nextTick(() => {
        const ta = textareaId ? document.getElementById(textareaId) : null
        if (ta) {
          ta.focus()
          const cursorPos = atStart + displayText.length
          ta.setSelectionRange(cursorPos, cursorPos)
        }
      })
    },
    repositionMention() {
      const el = this.$refs.mentionEl
      if (!el) return
      const m = this.mentionMenu
      if (!m || m.anchorTop == null) return
      const actualH = el.offsetHeight
      this.mentionTop = Math.max(12, m.anchorTop - actualH - 8)
    },
    handleGlobalClick() { this.CLOSE_TELEGRAM_MENUS() },
    handleKeydown(e) { if (e.key === 'Escape') this.CLOSE_TELEGRAM_MENUS() },
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick)
    document.addEventListener('keydown', this.handleKeydown)
    this._onOpenMM = () => this.openMemberManager()
    window.addEventListener('open-member-manager', this._onOpenMM)
    this.$nextTick(() => {
      const overlay = this.$refs.dismissOverlay
      if (overlay && overlay.parentNode !== document.body) {
        document.body.appendChild(overlay)
      }
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
    document.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('open-member-manager', this._onOpenMM)
    const overlay = this.$refs.dismissOverlay
    if (overlay && overlay.parentNode === document.body) {
      document.body.removeChild(overlay)
    }
  }
}
</script>

<style scoped>
.telegram-menus-host {
  position: fixed; top: 0; left: 0; z-index: 200; pointer-events: none;
}
.telegram-menus-host > * { pointer-events: all; }
.telegram-mention-ai-tag {
  padding: 2px 6px; border-radius: 4px;
  background: rgba(90,110,255,0.12); color: #5a6eff;
  font-size: 10px; font-weight: 700; flex: 0 0 auto;
}

/* ── 群成员管理弹窗 ── */
.mm-overlay {
  position: fixed; inset: 0; z-index: 200;
  display: flex; align-items: center; justify-content: center;
  background: rgba(27,39,57,.26);
}
.mm-dialog {
  width: min(420px, calc(100vw - 32px)); max-height: 80vh;
  border-radius: 24px; background: rgba(255,255,255,.98);
  border: 1px solid rgba(71,97,128,.10);
  box-shadow: 0 24px 60px rgba(26,40,61,.22);
  display: flex; flex-direction: column; overflow: hidden;
  padding: 0;
}
.mm-dialog .group-dialog-head { min-height: 58px; padding: 0 18px; display: flex; align-items: center; justify-content: space-between; gap: 12px; border-bottom: 1px solid rgba(71,97,128,.06); }
.mm-dialog .group-dialog-search { margin: 12px 18px 8px; width: calc(100% - 36px); box-sizing: border-box; }
.mm-dialog .group-dialog-note { padding: 0 18px 8px; }
.mm-dialog .group-dialog-member-list { flex: 1; min-height: 0; overflow-y: auto; padding: 0 10px; }
.mm-foot { padding: 12px 18px; display: flex; justify-content: flex-end; border-top: 1px solid rgba(71,97,128,.06); }
.member-manager-actions { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.member-manager-ai-tag {
  padding: 1px 6px; border-radius: 4px; font-size: 10px; font-weight: 800;
  background: rgba(91,141,239,.1); color: #5B8DEF;
}
.member-manager-owner-tag {
  padding: 1px 6px; border-radius: 4px; font-size: 10px; font-weight: 800;
  background: rgba(245,158,11,.1); color: #d97706;
}
.member-manager-remove-btn {
  background: rgba(239,68,68,.10) !important; color: #dc2626 !important; flex-shrink: 0;
}
.member-manager-remove-btn:hover { background: rgba(239,68,68,.18) !important; }

/* ── Forward Modal ── */
.forward-overlay { position: fixed; inset: 0; z-index: 400; background: rgba(20,35,58,0.36); display: flex; align-items: center; justify-content: center; }
.forward-panel { width: min(720px, 92vw); height: min(520px, 80vh); display: flex; border-radius: 16px; background: #fff; box-shadow: 0 24px 60px rgba(28,45,69,0.18); overflow: hidden; }
.forward-left { width: 280px; border-right: 1px solid rgba(228,233,242,0.8); display: flex; flex-direction: column; flex-shrink: 0; }
.forward-search { padding: 12px; display: flex; align-items: center; gap: 8px; border-bottom: 1px solid rgba(228,233,242,0.7); }
.forward-search input { flex: 1; border: none; outline: none; font-size: 13px; font-family: inherit; color: #2d4158; background: transparent; }
.forward-search svg { color: #94A4B5; flex-shrink: 0; }
.forward-list { flex: 1; overflow: auto; padding: 6px; }
.forward-group-label { font-size: 11px; font-weight: 800; color: #94A4B5; letter-spacing: .06em; text-transform: uppercase; padding: 10px 10px 4px; }
.forward-item { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 8px; cursor: pointer; transition: background .12s; }
.forward-item:hover { background: rgba(91,141,239,0.05); }
.forward-item.selected { background: rgba(91,141,239,0.08); }
.forward-check { width: 18px; height: 18px; border-radius: 50%; border: 2px solid #c8d4e3; flex-shrink: 0; transition: background .12s, border-color .12s; position: relative; }
.forward-check.checked { background: #5B8DEF; border-color: #5B8DEF; }
.forward-check.checked::after { content: '✓'; position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 11px; font-weight: 800; line-height: 1; }
.forward-avatar { width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg,#5B6DFF,#5B8DEF); color: #fff; font-size: 14px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; background-size: cover; background-position: center; }
.forward-info { min-width: 0; }
.forward-name { font-size: 13px; font-weight: 700; color: #1F3046; display: flex; align-items: center; gap: 6px; }
.forward-sub { font-size: 11px; color: #94A4B5; margin-top: 1px; }
.forward-tag { font-size: 10px; padding: 1px 6px; border-radius: 4px; font-weight: 700; }
.forward-tag.agent { color: #b8861f; background: rgba(255,244,210,0.92); }
.forward-tag.group { color: #7a56d6; background: rgba(122,86,214,0.12); }
.forward-tag.system { color: #fff; background: linear-gradient(135deg,#5B6DFF,#5B8DEF); }
.forward-right { flex: 1; display: flex; flex-direction: column; padding: 16px; }
.forward-right-head { font-size: 15px; font-weight: 700; color: #1F3046; display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.forward-right-link { font-size: 12px; color: #5B8DEF; font-weight: 600; }
.forward-right-hint { font-size: 12px; color: #94A4B5; }
.forward-selected-list { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 12px; max-height: 120px; overflow: auto; }
.forward-selected-item { display: flex; align-items: center; gap: 4px; padding: 4px 8px; border-radius: 6px; background: rgba(91,141,239,0.08); font-size: 12px; color: #2d4158; font-weight: 600; }
.forward-selected-remove { border: none; background: transparent; color: #94A4B5; cursor: pointer; font-size: 14px; padding: 0 2px; }
.forward-preview { padding: 12px; border-radius: 10px; background: rgba(228,233,242,0.4); margin-bottom: 10px; margin-top: auto; }
.forward-preview-label { font-size: 12px; font-weight: 700; color: #5B8DEF; margin-bottom: 4px; }
.forward-preview-text { font-size: 13px; color: #3c4d5f; line-height: 1.5; max-height: 60px; overflow: hidden; text-overflow: ellipsis; word-break: break-all; }
.forward-comment { width: 100%; padding: 10px 12px; border-radius: 10px; border: 1px solid rgba(228,233,242,0.9); font-size: 13px; color: #2d4158; font-family: inherit; outline: none; margin-bottom: 12px; box-sizing: border-box; }
.forward-comment:focus { border-color: rgba(91,141,239,0.4); }
.forward-actions { display: flex; gap: 8px; justify-content: flex-end; }
.forward-btn { padding: 8px 20px; border-radius: 8px; font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit; border: none; transition: background .12s; }
.forward-btn.primary { background: #5B8DEF; color: #fff; }
.forward-btn.primary:hover:not(:disabled) { background: #4a7de0; }
.forward-btn.primary:disabled { opacity: 0.5; cursor: not-allowed; }
.forward-btn.cancel { background: rgba(228,233,242,0.6); color: #6F8398; }
.forward-btn.cancel:hover { background: rgba(228,233,242,0.9); }

</style>
